<template>
  <div class="home-container">
    <div class="menu-container">
      <div class="logo-container">
        <img src="../assets/img/logo.png" alt="Asaas Logo" class="logo">
      </div>
      
      <nav class="menu">
        <div class="menu-group">
          <div class="menu-item" 
               @mouseenter="openMenu('migracoes')" 
               @mouseleave="startHideTimer('migracoes')">
            Migrações
          </div>
          <div class="submenu" 
               :class="{ 'open': activeMenu === 'migracoes' }"
               @mouseenter="cancelHideTimer"
               @mouseleave="startHideTimer('migracoes')">
            <router-link to="/migracoes/clientes" class="submenu-item">Clientes</router-link>
            <router-link to="#" class="submenu-item">Assinaturas</router-link>
          </div>
        </div>
        
        <div class="menu-group">
          <div class="menu-item" 
              @mouseenter="openMenu('pagamentos')" 
              @mouseleave="startHideTimer('pagamentos')">
            Pagamentos
          </div>
          <div class="submenu" 
              :class="{ 'open': activeMenu === 'pagamentos' }"
              @mouseenter="cancelHideTimer"
              @mouseleave="startHideTimer('pagamentos')">
            <router-link to="/planos" class="submenu-item">Plano Padrão</router-link>
          </div>
          <div class="submenu" 
              :class="{ 'open': activeMenu === 'pagamentos' }"
              @mouseenter="cancelHideTimer"
              @mouseleave="startHideTimer('pagamentos')">
            <router-link to="/promocional" class="submenu-item">Plano Promocional</router-link>
          </div>
          <div class="submenu" 
              :class="{ 'open': activeMenu === 'pagamentos' }"
              @mouseenter="cancelHideTimer"
              @mouseleave="startHideTimer('pagamentos')">
            <router-link to="/planodeg" class="submenu-item">Plano Degustação</router-link>
          </div>
          <div class="submenu" 
              :class="{ 'open': activeMenu === 'pagamentos' }"
              @mouseenter="cancelHideTimer"
              @mouseleave="startHideTimer('pagamentos')">
            <router-link to="/thyago" class="submenu-item">Representante Comercial Thyago</router-link>
          </div>
          <div class="submenu" 
              :class="{ 'open': activeMenu === 'pagamentos' }"
              @mouseenter="cancelHideTimer"
              @mouseleave="startHideTimer('pagamentos')">
            <router-link to="/profiautos" class="submenu-item">Representante ProfiAutos</router-link>
          </div>
        </div>

      </nav>      
    </div>

    <div class="chatbot-container" :class="{ 'pulse': showPulse }" @click="toggleChat">
      <img src="https://cdn-icons-png.flaticon.com/512/3670/3670051.png" alt="WhatsApp" class="whatsapp-icon">
    </div>
    
    <div v-if="showChat" class="chatbox">
      <div class="chatbox-header">
        <h3>Suporte</h3>
        <button @click="toggleChat" class="close-button">×</button>
      </div>
      <div class="chatbox-body">
        <textarea v-model="message" placeholder="Digite sua mensagem..." class="message-input"></textarea>
      </div>
      <div class="chatbox-footer">
        <button @click="sendMessage" class="send-button">Enviar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      showChat: false,
      showPulse: true,
      message: '',
      activeMenu: null,
      hideTimer: null
    }
  },
  methods: {
    toggleChat() {
      this.showChat = !this.showChat;
      if (this.showChat) {
        this.showPulse = false;
      }
    },
    sendMessage() {
      if (this.message.trim()) {
        const phoneNumber = '5585991994652';
        const encodedMessage = encodeURIComponent(this.message);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappUrl, '_blank');
        this.message = '';
        this.showChat = false;
      }
    },
    openMenu(menu) {
      this.cancelHideTimer();
      this.activeMenu = menu;
    },
    startHideTimer(menu) {
      this.hideTimer = setTimeout(() => {
        if (this.activeMenu === menu) {
          this.activeMenu = null;
        }
      }, 300); // Tempo suficiente para mover o mouse para o submenu
    },
    cancelHideTimer() {
      clearTimeout(this.hideTimer);
    }
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  position: relative;
}

.menu-container {
  width: 800px;
  min-height: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-top: 10px;
}

.logo-container {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  max-width: 300px;
  height: auto;
}

.menu {
  display: flex;
  flex-direction: column;
}

.menu-group {
  position: relative;
}

.menu-item {
  padding: 12px 20px;
  border-radius: 8px;
  color: #333;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.menu-item:hover {
  background-color: #f0f0f0;
  color: #F08B1B;
}

.submenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  position: relative;
  z-index: 2; /* Garante que o submenu fique acima dos outros elementos */
}

.submenu.open {
  max-height: 200px;
}

.submenu-item {
  padding: 10px 25px;
  border-radius: 6px;
  background-color: #f5f5f5;
  color: #555;
  text-decoration: none;
  transition: all 0.2s ease;
  display: block;
  margin-top: 5px;
}

.submenu-item:hover {
  background-color: #F08B1B;
  color: white;
}

/* Estilos do chatbot (mantidos do original) */
.chatbot-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.whatsapp-icon {
  width: 30px;
  height: 30px;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

.chatbox {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 300px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 1000;
}

.chatbox-header {
  background: #25D366;
  color: white;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
}

.chatbox-body {
  padding: 15px;
}

.message-input {
  width: 100%;
  height: 100px;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  resize: none;
  margin-bottom: 10px;
}

.chatbox-footer {
  padding: 10px 15px;
  display: flex;
  justify-content: flex-end;
  background: #f5f5f5;
}

.send-button {
  background-color: #25D366;
  color: white;
  border: none;
  padding: 8px 15px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.send-button:hover {
  background-color: #1da851;
}

@media (max-width: 850px) {
  .menu-container {
    width: calc(100% - 40px);
    min-height: auto;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .menu-container {
    padding: 15px;
  }
  
  .menu-item {
    padding: 10px 15px;
    font-size: 14px;
  }
  
  .chatbox {
    width: calc(100% - 40px);
    right: 20px;
    left: 20px;
  }
}
</style>